<div class="col col-md-12" *ngIf="cargandoDetalle">
    <div class="spinner-container">
        <ngx-spinner name="spinnerDetalle" bdOpacity=0.3bd Color="rgba(193,193,193,0)" size="medium" color="#185db5"
            type="ball-grid-beat" [fullScreen]="false">
            <p style="color: white">C a r g a n d o . . . </p>
        </ngx-spinner>
    </div>
</div>

<div class="card add-margin" *ngIf="!cargandoDetalle">
    <form [formGroup]="aeroplantaForm">
        <div class="card-header">
            <div class="row col-12">
                <h4 class="card-title">Aeroplanta: {{ this.aeroplantaSeleccionada.nombre }}</h4>
            </div>
        </div>
        <div class="card-body">

            <div *ngIf="this.authService.hasRole(TipoUsuario.JEFEDEAEROPLANTA)" class="d-flex flex-row mb-3">
                <label for="tipoAeroplantaFormControl" class="col-2 col-form-label">Responsable:</label>

                <div class="form-check form-check-inline p-2 col-4">
                    <select id="responsableFormControl" class="form-select" ngbTooltip="Seleccione un responsable"
                        formControlName="responsableFormControl">
                        <option *ngFor="let r of usuariosResponsableProducto" [ngValue]="r">
                            {{r.NombreCompleto}}
                        </option>
                    </select>
                    <loading-text-spinner *ngIf="cargandoResponsables" message="Obteniendo usuarios.." color="primary">
                    </loading-text-spinner>
                </div>

                <label for="tipoAeroplantaFormControl" class="col-1 col-form-label">Suplente:</label>
                <div class="form-check form-check-inline p-2 col-4">
                    <select id="suplenteFormControl" class="form-select" ngbTooltip="Seleccione un suplente"
                        formControlName="suplenteFormControl">
                        <option *ngFor="let r of usuariosResponsableProducto" [ngValue]="r">
                            {{r.NombreCompleto}}
                        </option>
                    </select>
                    <loading-text-spinner *ngIf="cargandoResponsables" message="Obteniendo usuarios.." color="primary">
                    </loading-text-spinner>
                </div>
            </div>

            <br>


            <div class="d-flex flex-nowrap mb-3 align-items-center">

                <div class="col-6 d-flex align-items-center gap-2">
                    <label class="col-form-label col-md-4 text-nowrap">*Tipo aeroplanta:</label>
                    <div class="d-flex gap-3 col-md-8">
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="tipoAeroplantaFormControl" id="checkPropia"
                                [value]="TipoAeroplanta.Propias" formControlName="tipoAeroplantaFormControl">
                            <label class="form-check-label" for="checkPropia">Propias</label>
                        </div>
                        <div class="form-check form-check-inline">
                            <input class="form-check-input" type="radio" name="tipoAeroplantaFormControl" id="checkTercera"
                                [value]="TipoAeroplanta.Terceras" formControlName="tipoAeroplantaFormControl">
                            <label class="form-check-label" for="checkTercera">Terceras</label>
                        </div>
                    </div>
                </div>

                <div class="col-6 d-flex align-items-center">
                    <label class="col-form-label text-nowrap">Obtener datos de telemedición</label>
                    <input class="form-check-input ms-2" type="checkbox" name="obtieneTelemedicionesFormControl"
                        id="checkTelemediciones" formControlName="obtieneTelemedicionesFormControl">
                </div>
            </div>
            <br>

            <!--Detalle Productos -->
            <div style="padding: 1em; border: 1px solid #ccc;">
                <div class="row">
                    <div class="mb-3 row col-12">
                        <label for="productoFormControl" class="col-12 col-form-label">Seleccione un producto:</label>
                        <div class="col-5">
                            <select id="productoFormControl" *ngIf="!this.cargandoProductos" class="form-select"
                                ngbTooltip="Seleccione un producto" formControlName="productoFormControl">
                                <option *ngFor="let p of productos" [ngValue]="p">
                                    ({{ p.codigoProducto }}) {{ p.nombreProducto }}
                                </option>
                            </select>
                            <loading-text-spinner *ngIf="cargandoProductos" message="Obteniendo productos.."
                                color="primary">
                            </loading-text-spinner>
                        </div>
                        <div class="col-3">
                            <button (click)="agregarProductoSeleccionada()" [disabled]="this.cargandoProductos"
                                type="button" class="btn btn-primary">Agregar
                            </button>
                        </div>
                    </div>
                </div>

                <nav class="navbar navbar-light bg-light navbar-expand-lg add-margin mb-1">
                    <div class="col-12 text-center">
                        <h5 class="mt-1">Detalle Productos</h5>
                    </div>
                </nav>
                <div class="alert alert-danger" *ngIf="this.detalleProductosFormControlArray.controls.length == 0">
                    No hay detalle productos configurados</div>
                <div *ngIf="(this.detalleProductosFormControlArray.controls.length > 0)"
                    class="row d-flex justify-content-around" formArrayName="detalleProductosFormControlArray">

                    <div class="mb-3 row col-5 ms-1 me-1" style="border: 1px solid #ccc; padding: 1em;"
                        *ngFor="let dp of detalleProductosSeleccionados; let i=index">
                        <div [formGroupName]="i">

                            <div class="row">
                                <div class="col-12">
                                    <div class="col-12 row" style="justify-content: center;">
                                        <label class="col-10 col-form-label me-2">
                                            <b>({{dp.codigoProducto}}) - {{dp.nombreProducto}}</b>
                                        </label>
                                        <button type="button" (click)="eliminarDetalle(i)"
                                            class="btn btn-danger ms-2 px-1 col-1">
                                            <i class="fa fa-trash" ngbTooltip="Borrar detalle del producto"></i>
                                        </button>
                                    </div>
                                    <div class="col-12 d-flex flex-row mt-2">
                                        <label class="col-4 col-form-label" for="codigoTerminal">*Terminal</label>
                                        <select id="codigoTerminal" *ngIf="!this.cargandoProductos" class="form-select"
                                            ngbTooltip="Seleccione una terminal" formControlName="codigoTerminal">
                                            <option *ngFor="let t of terminales" [ngValue]="t.codigoTerminal">
                                                <p>{{ t.codigoLetras }} - {{ t.nombre }}</p>
                                            </option>
                                        </select>
                                    </div>
                                    <input type="hidden" formControlName="codigoProducto">
                                    <div class="col-12 d-flex flex-row mt-2">
                                        <label class="col-8 col-form-label" for="distanciaEnKM">*Distancia en
                                            Kilometros</label>
                                        <input type="text" appOnlyNumber formControlName="distanciaEnKM"
                                            class="form-control" (change)="onChangeDistancia(i)" [maxlength]="6">
                                    </div>
                                    <div class="col-12 d-flex flex-row mt-2">
                                        <label class="col-8 col-form-label" for="toleranciaMensualOperativa">*Tolerancia
                                            mensual operativa (±)</label>
                                        <div class="input-group" style="padding-left: 0; padding-right: 0;">
                                            <input class="form-control" type="text" [min]="0" [max]="99.99"
                                                [maxlength]="6" appOnlyDecimalNegativa
                                                formControlName="toleranciaMensualOperativa">
                                            <span class="input-group-text">%</span>
                                        </div>
                                    </div>
                                    <div class="col-12 d-flex flex-row mt-2">
                                        <label class="col-8 col-form-label" for="diasPromedio">*Promedio de d&iacute;as</label>
                                        <input type="text" appOnlyNumber formControlName="diasPromedio"
                                            class="form-control" [maxlength]="6">
                                    </div>
                                    <div class="col-12 d-flex flex-row mt-2">
                                        <label class="col-8 col-form-label" for="diasDemora">*D&iacute;as demora:</label>
                                        <input type="text" appOnlyNumber formControlName="diasDemora"
                                            class="form-control" [maxlength]="6">
                                    </div>
                                    <div class="col-12 d-flex flex-row mt-2">
                                        <label class="col-8 col-form-label" for="stockSanitario">*Stock
                                            sanitario</label>
                                        <input type="text" appOnlyNumber formControlName="stockSanitario"
                                            class="form-control" [maxlength]="9">
                                    </div>
                                </div>
                            </div>

                            <div class="mt-1 alert alert-danger"
                                *ngIf="!detalleProductosFormControlArray.controls[i].valid">
                                (*) Datos obligatorios requeridos.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <br>
            <!-- Firma Operador -->
            <div class="border rounded p-3 mb-4">
                <h5 class="text-center mb-3">Firma Operador</h5>
                <div class="row mb-3 align-items-center py-2">
                    <div class="col-11">
                        <select class="form-select" formControlName="firmaOperadorFormControl"
                            *ngIf="!cargandoContactos">
                            <option *ngFor="let c of listOperadoresDisponibles" [ngValue]="c">
                                {{ c.nombre }}
                            </option>
                        </select>
                    </div>
                    <div class="col-1">
                        <button class="btn btn-success"
                            [disabled]="!firmaOperadorFormControl.value || cargandoContactos"
                            (click)="abmContacto(firmaOperadorFormControl.value, TipoResponsable.firmaOperadora)">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
                <ul class="list-group list-group-flush">
                    <li *ngFor="let item of listOperadoresSeleccionados" class="list-group-item bg-light px-0 py-2">
                        <div class="row align-items-center">
                            <div class="col-11 ps-4">{{ item.nombre }}</div>
                            <div class="col-1">
                                <button class="btn btn-danger"
                                    (click)="borrarContacto(item, TipoResponsable.firmaOperadora)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </li>
                    <li *ngIf="listOperadoresSeleccionados.length === 0" class="list-group-item px-0 py-2">
                        <ngb-alert [dismissible]="false" type="warning" class="mb-0">
                            No hay contactos firmas operadores configurados
                        </ngb-alert>
                    </li>
                </ul>
            </div>

            <!-- Referente Técnico -->
            <div class="border rounded p-3 mb-4">
                <h5 class="text-center mb-3">Referente Técnico</h5>
                <div class="row mb-3 align-items-center py-2">
                    <div class="col-11">
                        <select class="form-select" formControlName="referenteTecnicoFormControl"
                            *ngIf="!cargandoContactos">
                            <option *ngFor="let c of listRefTecnicosDisponibles" [ngValue]="c">
                                {{ c.nombre }}
                            </option>
                        </select>
                    </div>
                    <div class="col-1">
                        <button class="btn btn-success"
                            [disabled]="!referenteTecnicoFormControl.value || cargandoContactos"
                            (click)="abmContacto(referenteTecnicoFormControl.value, TipoResponsable.referenteTecnico)">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
                <ul class="list-group list-group-flush">
                    <li *ngFor="let item of listRefTecnicosSeleccionados" class="list-group-item bg-light px-0 py-2">
                        <div class="row align-items-center">
                            <div class="col-11 ps-4">{{ item.nombre }}</div>
                            <div class="col-1">
                                <button class="btn btn-danger"
                                    (click)="borrarContacto(item, TipoResponsable.referenteTecnico)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </li>
                    <li *ngIf="listRefTecnicosSeleccionados.length === 0" class="list-group-item px-0 py-2">
                        <ngb-alert [dismissible]="false" type="warning" class="mb-0">
                            No hay contactos referentes técnicos configurados
                        </ngb-alert>
                    </li>
                </ul>
            </div>

            <!-- Referente Gestión -->
            <div class="border rounded p-3 mb-4">
                <h5 class="text-center mb-3">Referente Gestión</h5>
                <div class="row mb-3 align-items-center py-2">
                    <div class="col-11">
                        <select class="form-select" formControlName="referenteGestionFormControl"
                            *ngIf="!cargandoContactos">
                            <option *ngFor="let c of listRefGestionDisponibles" [ngValue]="c">
                                {{ c.nombre }}
                            </option>
                        </select>
                    </div>
                    <div class="col-1">
                        <button class="btn btn-success"
                            [disabled]="!referenteGestionFormControl.value || cargandoContactos"
                            (click)="abmContacto(referenteGestionFormControl.value, TipoResponsable.referenteGestion)">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
                <ul class="list-group list-group-flush">
                    <li *ngFor="let item of listRefGestionSeleccionados" class="list-group-item bg-light px-0 py-2">
                        <div class="row align-items-center">
                            <div class="col-11 ps-4">{{ item.nombre }}</div>
                            <div class="col-1">
                                <button class="btn btn-danger"
                                    (click)="borrarContacto(item, TipoResponsable.referenteGestion)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </li>
                    <li *ngIf="listRefGestionSeleccionados.length === 0" class="list-group-item px-0 py-2">
                        <ngb-alert [dismissible]="false" type="warning" class="mb-0">
                            No hay contactos referentes de gestión configurados
                        </ngb-alert>
                    </li>
                </ul>
            </div>

            <!-- Referente Comercial -->
            <div class="border rounded p-3 mb-4">
                <h5 class="text-center mb-3">Referente Comercial</h5>
                <div class="row mb-3 align-items-center py-2">
                    <div class="col-11">
                        <select class="form-select" formControlName="referenteComercialFormControl"
                            *ngIf="!cargandoContactos">
                            <option *ngFor="let c of listRefComercialDisponibles" [ngValue]="c">
                                {{ c.nombre }}
                            </option>
                        </select>
                    </div>
                    <div class="col-1">
                        <button class="btn btn-success"
                            [disabled]="!referenteComercialFormControl.value || cargandoContactos"
                            (click)="abmContacto(referenteComercialFormControl.value, TipoResponsable.referenteComercial)">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
                <ul class="list-group list-group-flush">
                    <li *ngFor="let item of listRefComercialSeleccionados" class="list-group-item bg-light px-0 py-2">
                        <div class="row align-items-center">
                            <div class="col-11 ps-4">{{ item.nombre }}</div>
                            <div class="col-1">
                                <button class="btn btn-danger"
                                    (click)="borrarContacto(item, TipoResponsable.referenteComercial)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </li>
                    <li *ngIf="listRefComercialSeleccionados.length === 0" class="list-group-item px-0 py-2">
                        <ngb-alert [dismissible]="false" type="warning" class="mb-0">
                            No hay contactos referentes comerciales configurados
                        </ngb-alert>
                    </li>
                </ul>
            </div>

            <!-- Ruteador -->
            <div class="border rounded p-3 mb-4">
                <h5 class="text-center mb-3">Ruteador</h5>
                <div class="row mb-3 align-items-center py-2">
                    <div class="col-11">
                        <select class="form-select" formControlName="ruteadorFormControl" *ngIf="!cargandoContactos">
                            <option *ngFor="let c of listRuteadoresDisponibles" [ngValue]="c">
                                {{ c.nombre }}
                            </option>
                        </select>
                    </div>
                    <div class="col-1">
                        <button class="btn btn-success"
                            [disabled]="!ruteadorFormControl.value || cargandoContactos"
                            (click)="abmContacto(ruteadorFormControl.value, TipoResponsable.ruteador)">
                            <i class="fa fa-plus"></i>
                        </button>
                    </div>
                </div>
                <ul class="list-group list-group-flush">
                    <li *ngFor="let item of listRuteadoresSeleccionados" class="list-group-item bg-light px-0 py-2">
                        <div class="row align-items-center">
                            <div class="col-11 ps-4">{{ item.nombre }}</div>
                            <div class="col-1">
                                <button class="btn btn-danger"
                                    (click)="borrarContacto(item, TipoResponsable.ruteador)">
                                    <i class="fa fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </li>
                    <li *ngIf="listRuteadoresSeleccionados.length === 0" class="list-group-item px-0 py-2">
                        <ngb-alert [dismissible]="false" type="warning" class="mb-0">
                            No hay contactos ruteadores configurados
                        </ngb-alert>
                    </li>
                </ul>
            </div>


            <div class="d-flex flex-row col-12 mt-2 mb-2">
                <label class="col-3 col-form-label" for="horarioOperadorFormControl">Horario Operacion</label>
                <input type="text" class="form-control" formControlName="horarioOperacionFormControl" />
                <div class="col-4"></div>
            </div>

            <div class="card-footer d-flex justify-content-center">
                <span class="border">
                    <button type="button" class="btn btn-primary" (click)="onClick()" [disabled]="guardando">
                        <span *ngIf="!guardando">Guardar cambios</span>
                        <div *ngIf="guardando" class="d-flex align-items-center">
                            <div class="spinner-border text-light spinner-border-sm" role="status"></div>
                            <span>Guardando...</span>
                        </div>
                    </button>
                </span>
            </div>
        </div>
    </form>
</div>
